import realTimeAlarm from './realTimeAlarm.vue';
export default {
  // install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
  install: function(Vue){
    if (Vue) {
      let instance;
      const ALARM = Vue.extend(realTimeAlarm);
      const createEl = () => {
        instance = new ALARM({
          el: document.createElement('div')
        });
      };
    
      let alarm = {
        /** 
                 * 显示告警弹窗
                 * @param {Object} config 配置对象
                 */
        show(config) {
          createEl();
          instance.showModal = true;
          Object.assign(instance, config || {});
          document.getElementById('app').appendChild(instance.$el);
          return instance;
        },
    
        /** 
                 * 关闭告警弹窗
                 */
        hide() {
          if (instance) {
            instance.showModal = false;
          }
        },

        /** 
                 * 关闭所有告警弹窗
                 */
        closeAll() {
          let el = document.getElementsByClassName('real-time-alarm');
          while(el[0]){
            el[0].parentNode.removeChild(el[0]); 
          }
        }
      };
      Vue.prototype.$alarm = alarm;
      return alarm;
    }
  }
};